/************
 * Developed by : Shiva Software Solutions
 * Date : 23-06-2021
 * Descriptions : Call api response using reducers
 ************/
import { act } from 'react';
import {
  CLIENT_DASHBOARD_DETAILS,
  GET_HC_DATA,
  SEARCH_PATIENT_LIST,
  SEARCH_PATIENT_LIST_COUNT,
  DASHBOARD_PENDING_DATA,
  DASHBOARD_PENDING_COUNT,
  PATIENT_SUCCESS_MSG,
  ERX_SUCCESS_MSG,
  DASHBOARD_INSERT_PRESCRIPTION,
  DASHBOARD_INPROGRESSS_DATA,
  DASHBOARD_INPROGRESSS_COUNT,
  DOCTOR_SUCCESS_MSG,
  REJECT_ERX_MSG,
  DOCTOR_UPDATE_MSG,
  MEDICINE_SUCCESS_MSG,
  DASHBOARD_ERX_DOCPROCEDURE,
  DASHBOARD_REJECT_DATA,
  DASHBOARD_REJECT_COUNT,
  REJECT_ERX_SUCCESS_MSG,
  DASHBOARD_COMPLETED_COUNT,
  DASHBOARD_COMPLETED_DATA,
  DELETE_MEDCINE_SUCCESS_MSG,
  DEPARTMENT_MASTER,
  CHANGE_MOBILENO_RES,
  SEARCH_REPORTS_DATA,
  PATIENT_LISTS,
  GET_VENDOR_LIST,
  CLIENT_EXCEL_LIST,
  VACC_EXCEL_LIST,
  AGE_VACCINATION_LIST,
  APPOINTMENT_REASON,
  SETTINGS,
  pulseList,
  weightList,
  durationList,
  REFERRALLIST,
  DOSAGELIST,
  bpList,
  CLIENT_BILLING_DETAILS,
  spo2List,
  tempList,
  hemoglobinList,
  serumList,
  bloodureaList,
  VENDOR_LIST,
  USER_PERMISSIONS,
  tlcount,
  MEDIA_lIST,
  CLIENT_DEPT_LIST,
  CLIENT_DR_LIST,
  CLIENT_DOWNLOAD_LIST,
  CLIENT_INSERT_MSG,
  CLIENT_PATIENT_VACCLIST,
  CLIENT_PATIENT_VACCTOTAL,
  CLIENT_DOWNLOAD_LIST_COUNT,
  CLIENT_ERX_LIST,
  CLIENT_ERX_LIST_COUNT,
  CLIENT_ERX_TOTAL_FEES,
  REJECT_REASONS,
  APPOINTMENT_PATIENTS,
  CLIENT_LIST,
  OPERATOR_LIST,
  GET_CAMERA_LIST,
  GET_CLIENT_MASTERS,
  CLIENT_DASHBOARD_TAT,
  DOCTOR_INSERT_MSG,
  INSERT_OWN_ERX_SUCCESS,
  CLIENT_DOCTOR_LIST,
  UPLOAD_WARNING,
  INSERT_ERROR_INDEX,
  BUCKET_CAPTCHA,
  SUGGEST_PAT_MESSAGE,
  SUGGEST_PAT,
  OPDDIGITIZATION_COUNT,
  PRESCRIPTION_COUNT,
  OPDDIGITIZATION_MEDICINE,
  DIGITIZATION_DISEASE,
  INVESTIGATION_LAB,
  INVESTIGATION_RADIO,
  ONLINE_OFFLINE_STATUS,
  DOCTORTAB_PARAM,
  DOCTOR_REDIRECTURL,
  DOCTORPORTAL_TRIGGER,
  CLIENT_DASHBOARD_SETTINGS,
  MEDICINE_CATEGORY_COUNT,
  DOCTOR_SPECIALIZATION_COUNT,
  INVESTIGATION_MRI_XRay,
  INVESTIGATION_BLOOD_TEST,
  INVESTIGATION_CATEGORY,
  INVESTIGATION_CATEGORY_DATA,
  PRESCRIPTION_LOADER,
  ANTIBIOTIC_LOADER,
  DISEASE_LOADER,
  LAB_LOADER,
  RADIOLOGY_LOADER,
  MRI_XRAY_LOADER,
  SPECIALIZATION_LOADER,
  INVESCATEGORY_LOADER,
  BLOODTEST_LOADER,
  DISCHARGE_COUNT,
  DISCHARGE_FILELIST,
  DISCHARGE_APIRES,
  MRD_DR_DETS,
  MRD_HEADER_MASTER,
  MRD_DETS,
  DISCHARGE_SUMMARY,
  DISCHARGE_LIST,
  DISCHARGE_COM_COUNT,
  DISCHARGE_COM_LIST,
  MRD_HEADER_MASTER_SAVE,
  MRD_NOTIFICATIONS,
  MRD_OPEN_NOTIFI,
  MRD_NOTIFI_TEXT,
  DIGIPOD_AUDIO_LIST,
  DIGIPOD_AUDIO_COUNT,
  DOWNLOAD_LINK,
  GET_ERX_FORMS_PDF,
  GET_REGISTERED_CLIENTS_DOCTORS,
  REGI_REPORT_RESULT,
  ALTERNATIVE_MEDICINE_LIST,
  TOTAL_MEDICINE,
  TOTAL_UNIQUE_MEDICINE,
  ALTERNATIVE_MEDICINE_REPORT,
  MISSED_MEDICINE_LIST,
  MISSED_MEDICINE_REPORT,
  NEW_MEDICINE_LIST,
  TOTAL_NEW_MEDICINE,
  NEW_MEDICINE_REPORT,
  NEW_MEDICINE_SUGG_LIST,
  TOTAL_NEW_MEDICINE_SUGG,
  NEW_MEDICINE_SUGG_REPORT,
  DOCTORWISE_MISSEDMED_LIST,
  TOTAL_DOCTOR_LIST,
  DOCTROWISEMISSED_MEDICINE_REPORT,
  ALTERNATIVE_UNIQUE_LIST,
  TOTAL_MEDICINE_RECORD,
  UPLOAD_SIGNATURE_URL,
  UPLOAD_SIGNATURE_STATUS,
  CHART_ERX_RESULT,
  CHART_ERX_TOTAL_RECORD,
  CHART_ERX_DETAILS_LOADER,
  PROCEDURE_CHART_DATA,
  PROCEDURE_LOADER,
  SUPER_ADMIN_CLIENTS,
  SADMIN_CLI_DTLS,
  GET_FORMTYPE
} from '../../shared/constants/ActionTypes';

const initialState = {
  clientDownloadList: [],
  clientInsertMsg: '',
  mrdNotifiText: null,
  healthCare: null,
  dashboardPendingList: {},
  pendingCount: 0,
  clientDownloadListCount: 0,
  weightList: [],
  tempList: {},
  docRedirectUrl: '',
  owneRx_succes: '',
  spo2List: {},
  bucketCaptcha: {},
  suggestpat: [],
  clientDeptList: [],
  suggestionpatmessage: '',
  clientErxList: {},
  clientErxListCount: 0,
  tlcount: {},
  patientsuccessmsg: null,
  erxsuccessmsg: null,
  rejecterxsuccessmsg: null,
  erxmedicinesuccessmsg: null,
  dashboarderxDocProcedure: [],
  dosageList: [],
  referralList: [],
  doctorDetails: {},
  dashboardinsertprescriptions: {},
  inprogresCount: 0,
  dashboardInprogressList: {},
  dashboardRejectList: {},
  dashboardRejectcountList: null,
  doctorsuccessmsg: null,
  doctorupdatemsg: null,
  rejectsuccessmsg: null,
  dashboardCompletedList: {},
  dashboardCompletedcountList: null,
  bpList: {},
  deletemedicinesuccessmsg: null,
  qualifications: [],
  departmentMaster: [],
  clientExcelDetails: {},
  vaccExcelDetails: [],
  age_vaccine_list: [],
  search_patient_list: [],
  search_patient_list_count: 0,
  optNotes: '',
  doctorSearchDatas: [],
  searchableDoctor: {},
  changemobilenores: '',
  searchReportsData: [],
  clientBillingDetails: {},
  patientListdata: [],
  searchReportsData: [],
  serumList: {},
  pulseList: {},
  hemoglobinList: {},
  bloodureaList: {},
  clientBillingDetails: {},
  clientDashboardDetails: {},
  clientTotalErxFees: 0,
  cameraDash: [],
  getClientlist: [],
  clientTAT: null,
  doctorInsertMsg: '',
  doctorList: [],
  uploadWarning: '',
  inserErrorIndex: '',
  opddigitization_report_count: {},
  opddigitization_report_medicine: [],
  digitization_report_diseases: [],
  inves_labtype: [],
  inves_radiotype: [],
  clientVaccList: [],
  clientVaccTotal: 0,
  onlineOfflineStatus: {},
  doctorTabParams: {},
  doctorportal_trigger: null,
  client_dashboard_settings: {},
  clientDrList: [],
  mediaList: [],
  medicine_category_count: [],
  doctor_specialization: [],
  inves_MRI_XRay: [],
  inves_category: [],
  category_master: [],
  prescription_count: {},
  prescription_loader: false,
  antibiotic_loader: false,
  disease_loader: false,
  lab_loader: false,
  radiology_loader: false,
  specialization_loader: false,
  mri_xray_loader: false,
  invescategory_loader: false,
  bloodtest_loader: false,
  disCount: 0,
  disList: [],
  disComCount: 0,
  disComList: [],
  disFileList: '',
  disSummary: '',
  disApiRes: '',
  mrdDetails: '',
  mrdDrDtls: [],
  mrdHeaderMaster: [],
  mrdHeaderMasterSave: '',
  MTnotifications: [],
  mrdOpenNotifi: false,
  digiaudioList: [],
  audioCount: 0,
  download_link: '',
  getErxFormsPDF: [],
  get_registered_clients_doctors: [],
  rigireportresult: [],
  alternative_medicine_list: [],
  total_medicine: '0',
  unique_medicine: '0',
  excel_result: [],
  missed_medicine_list: [],
  missed_medicine_export: [],
  new_medicine_list: [],
  excel_new_medicines: [],
  total_new_medicine: '0',
  new_medicine_sugg_list: [],
  excel_new_medicines_sugg: [],
  total_new_medicine_sugg: '0',
  doctorwise_missed_medicine:[],
  total_doctor_list:0,
  doctorwise_excel :[],
  alternate_unique_list :[],
  total_medicine_record:0,
  uploaded_signature_url:'',
  uploaded_signature_status:'',
  charteRxResult:{},
  chartErxTotalRecord:0,
  charteRxdetailsLoader: false,
  procedureChart:[],
  procedure_loader:false,
  superAdminClients: [],
  sAdminCliDtls:[],
  formtype_master:[]
};
const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case MRD_OPEN_NOTIFI:
      return {
        ...state,
        mrdOpenNotifi: action.payload,
      };
    case MRD_NOTIFI_TEXT:
      return {
        ...state,
        mrdNotifiText: action.payload,
      };

    case MRD_DETS:
      return {
        ...state,
        mrdDetails: action.payload,
      };
    case MRD_HEADER_MASTER:
      return {
        ...state,
        mrdHeaderMaster: action.payload,
      };
    case MRD_DR_DETS:
      return {
        ...state,
        mrdDrDtls: action.payload,
      };
    case DISCHARGE_APIRES:
      return {
        ...state,
        disApiRes: action.payload,
      };
    case MRD_HEADER_MASTER_SAVE:
      return {
        ...state,
        mrdHeaderMasterSave: action.payload,
      };
    case DISCHARGE_FILELIST:
      return {
        ...state,
        disFileList: action.payload,
      };
    case DISCHARGE_SUMMARY:
      return {
        ...state,
        disSummary: action.payload,
      };
    case DISCHARGE_COUNT:
      return {
        ...state,
        disCount: action.payload,
      };
    case DISCHARGE_LIST:
      return {
        ...state,
        disList: action.payload,
      };
    case DISCHARGE_COM_COUNT:
      return {
        ...state,
        disComCount: action.payload,
      };
    case DISCHARGE_COM_LIST:
      return {
        ...state,
        disComList: action.payload,
      };

    case CLIENT_LIST:
      return {
        ...state,
        clientList: action.payload,
      };
    case CLIENT_BILLING_DETAILS:
      return {
        ...state,
        clientBillingDetails: action.payload,
      };
    case BUCKET_CAPTCHA:
      return {
        ...state,
        bucketCaptcha: action.payload,
      };
    //Get VENDOR_LIST
    case VENDOR_LIST:
      return {
        ...state,
        vendorList: action.payload,
      };
    case SEARCH_PATIENT_LIST:
      return {
        ...state,
        search_patient_list: action.payload,
      };
    case SUGGEST_PAT_MESSAGE:
      return {
        ...state,
        suggestionpatmessage: action.payload,
      };
    case SUGGEST_PAT:
      return {
        ...state,
        suggestpat: action.payload,
      };
    case SEARCH_PATIENT_LIST_COUNT:
      return {
        ...state,
        search_patient_list_count: action.payload,
      };

    //Get ERXREPORT data
    case CLIENT_ERX_LIST:
      return {
        ...state,
        clientErxList: action.payload,
      };
    case CLIENT_ERX_TOTAL_FEES:
      return {
        ...state,
        clientTotalErxFees: action.payload,
      };
    //Get completed count data
    case CLIENT_ERX_LIST_COUNT:
      return {
        ...state,
        clientErxListCount: action.payload,
      };
    case CLIENT_DASHBOARD_DETAILS:
      return {
        ...state,
        clientDashboardDetails: action.payload,
      };
    case CLIENT_DASHBOARD_TAT:
      return {
        ...state,
        clientTAT: action.payload,
      };
    case OPERATOR_LIST:
      return {
        ...state,
        operatorList: action.payload,
      };
    case GET_VENDOR_LIST:
      return {
        ...state,
        clientBillingDetails: action.payload,
      };
    case APPOINTMENT_PATIENTS:
      return {
        ...state,
        appointmentPatients: action.payload,
      };
    //Get REJECT_REASONS
    case REJECT_REASONS:
      return {
        ...state,
        rejectReasons: action.payload,
      };
    //Get MEDIAlIST
    case MEDIA_lIST:
      return {
        ...state,
        mediaList: action.payload,
      };
    case CLIENT_DEPT_LIST:
      return {
        ...state,
        clientDeptList: action.payload,
      };
    case CLIENT_DR_LIST:
      return {
        ...state,
        clientDrList: action.payload,
      };
    case CLIENT_INSERT_MSG:
      return {
        ...state,
        clientInsertMsg: action.payload,
      };
    case CLIENT_PATIENT_VACCLIST:
      return {
        ...state,
        clientVaccList: action.payload,
      };
    case CLIENT_PATIENT_VACCTOTAL:
      return {
        ...state,
        clientVaccTotal: action.payload,
      };
    case CLIENT_DOWNLOAD_LIST:
      return {
        ...state,
        clientDownloadList: action.payload,
      };
    case CLIENT_DOWNLOAD_LIST_COUNT:
      return {
        ...state,
        clientDownloadListCount: action.payload,
      };
    //Get blood urea list data
    case bloodureaList:
      return {
        ...state,
        bloodureaList: action.payload,
      };
    //Get serum List
    case serumList:
      return {
        ...state,
        serumList: action.payload,
      };
    //Get tl count
    case tlcount:
      return {
        ...state,
        tlcount: action.payload,
      };
    //Get user permissions
    case USER_PERMISSIONS:
      return {
        ...state,
        userPermissions: action.payload,
      };
    case SETTINGS:
      return {
        ...state,
        settings: action.payload,
      };
    //Get hemoglobin List
    case hemoglobinList:
      return {
        ...state,
        hemoglobinList: action.payload,
      };
    //Get spo2 list
    case spo2List:
      return {
        ...state,
        spo2List: action.payload,
      };
    //Get pulse list
    case pulseList:
      return {
        ...state,
        pulseList: action.payload,
      };
    case tempList:
      return {
        ...state,
        tempList: action.payload,
      };
    //Get BP list data
    case bpList:
      return {
        ...state,
        bpList: action.payload,
      };
    //Get dosage list
    case DOSAGELIST:
      return {
        ...state,
        dosageList: action.payload,
      };
    //Get referralList
    case REFERRALLIST:
      return {
        ...state,
        referralList: action.payload,
      };
    //Get pulse list
    case weightList:
      return {
        ...state,
        weightList: action.payload,
      };

    //Get durationList
    case durationList:
      return {
        ...state,
        durationList: action.payload,
      };
    case APPOINTMENT_REASON:
      return {
        ...state,
        appointmentReason: action.payload,
      };
    case CLIENT_EXCEL_LIST:
      return {
        ...state,
        clientExcelDetails: action.payload,
      };
    case VACC_EXCEL_LIST:
      return {
        ...state,
        vaccExcelDetails: action.payload,
      };
    case AGE_VACCINATION_LIST:
      return {
        ...state,
        age_vaccine_list: action.payload,
      };
    case GET_HC_DATA:
      return {
        ...state,
        healthCare: action.payload,
      };

    //Assign dashboard pending data
    case DASHBOARD_PENDING_DATA:
      return {
        ...state,
        dashboardPendingList: action.payload,
      };
    //Assign dashboard pending count
    case DASHBOARD_PENDING_COUNT:
      return {
        ...state,
        pendingCount: action.payload,
      };
    //Assign dashboard pending data
    case DASHBOARD_REJECT_DATA:
      return {
        ...state,
        dashboardRejectList: action.payload,
      };
    //Assign dashboard pending count
    case DASHBOARD_REJECT_COUNT:
      return {
        ...state,
        dashboardRejectcountList: action.payload,
      };

    //Assign dashboard pending Patient success msg
    case PATIENT_SUCCESS_MSG:
      return {
        ...state,
        patientsuccessmsg: action.payload,
      };
    //Assign successmsg
    case ERX_SUCCESS_MSG:
      return {
        ...state,
        erxsuccessmsg: action.payload,
      };
    //Assign successmsg
    case REJECT_ERX_MSG:
      return {
        ...state,
        rejecterxsuccessmsg: action.payload,
      };

    //Assign successmsg
    case MEDICINE_SUCCESS_MSG:
      return {
        ...state,
        erxmedicinesuccessmsg: action.payload,
      };

    case DASHBOARD_ERX_DOCPROCEDURE:
      return {
        ...state,
        dashboarderxDocProcedure: action.payload,
      };

    //Insert prescription
    case DASHBOARD_INSERT_PRESCRIPTION:
      return {
        ...state,
        dashboardinsertprescriptions: action.payload,
      };
    //Assign dashboard inprogress data
    case DASHBOARD_INPROGRESSS_DATA:
      return {
        ...state,
        dashboardInprogressList: action.payload,
      };
    //Assign inprogress count
    case DASHBOARD_INPROGRESSS_COUNT:
      return {
        ...state,
        inprogresCount: action.payload,
      };
    //doctor success msg
    case DOCTOR_SUCCESS_MSG:
      return {
        ...state,
        doctorsuccessmsg: action.payload,
      };

    //doctor update msg
    case DOCTOR_UPDATE_MSG:
      return {
        ...state,
        doctorupdatemsg: action.payload,
      };

    //REJECT_ERX_SUCCESS_MSG
    case REJECT_ERX_SUCCESS_MSG:
      return {
        ...state,
        rejectsuccessmsg: action.payload,
      };

    case DASHBOARD_COMPLETED_DATA:
      return {
        ...state,
        dashboardCompletedList: action.payload,
      };
    case DASHBOARD_COMPLETED_COUNT:
      return {
        ...state,
        dashboardCompletedcountList: action.payload,
      };

    //Assign delete medicine details
    case DELETE_MEDCINE_SUCCESS_MSG:
      return {
        ...state,
        deletemedicinesuccessmsg: action.payload,
      };

    // master list
    case DEPARTMENT_MASTER:
      return {
        ...state,
        departmentMaster: action.payload,
      };
    case CHANGE_MOBILENO_RES:
      return {
        ...state,
        changemobilenores: action.payload,
      };

    case SEARCH_REPORTS_DATA:
      return {
        ...state,
        searchReportsData: action.payload,
      };
    case PATIENT_LISTS:
      return {
        ...state,
        patientListdata: action.payload,
      };
    case SEARCH_REPORTS_DATA:
      return {
        ...state,
        searchReportsData: action.payload,
      };
    case GET_CAMERA_LIST:
      return {
        ...state,
        cameraDash: action.payload,
      };
    case GET_CLIENT_MASTERS:
      return {
        ...state,
        getClientlist: action.payload,
      };
    case DOCTOR_INSERT_MSG:
      return {
        ...state,
        doctorInsertMsg: action.payload,
      };
    case INSERT_OWN_ERX_SUCCESS:
      return {
        ...state,
        owneRx_succes: action.payload,
      };
    case CLIENT_DOCTOR_LIST:
      return {
        ...state,
        doctorList: action.payload,
      };
    case UPLOAD_WARNING:
      return {
        ...state,
        uploadWarning: action.payload,
      };
    case INSERT_ERROR_INDEX:
      return {
        ...state,
        inserErrorIndex: action.payload,
      };
    case OPDDIGITIZATION_COUNT:
      return {
        ...state,
        opddigitization_report_count: action.payload,
      };
    case OPDDIGITIZATION_MEDICINE:
      return {
        ...state,
        opddigitization_report_medicine: action.payload,
      };
    case DIGITIZATION_DISEASE:
      return {
        ...state,
        digitization_report_diseases: action.payload,
      };
    case INVESTIGATION_LAB:
      return {
        ...state,
        inves_labtype: action.payload,
      };
    case INVESTIGATION_RADIO:
      return {
        ...state,
        inves_radiotype: action.payload,
      };
    //Get online offline status
    case ONLINE_OFFLINE_STATUS:
      return {
        ...state,
        onlineOfflineStatus: action.payload,
      };
    case DOCTORTAB_PARAM:
      return {
        ...state,
        doctorTabParams: action.payload,
      };
    case DOCTOR_REDIRECTURL:
      return {
        ...state,
        docRedirectUrl: action.payload,
      };

    case DOCTORPORTAL_TRIGGER:
      return {
        ...state,
        doctorportal_trigger: action.payload,
      };
    case CLIENT_DASHBOARD_SETTINGS:
      return {
        ...state,
        client_dashboard_settings: action.payload,
      };
    case MEDICINE_CATEGORY_COUNT:
      return {
        ...state,
        medicine_category_count: action.payload,
      };
    case DOCTOR_SPECIALIZATION_COUNT:
      return {
        ...state,
        doctor_specialization: action.payload,
      };

    case INVESTIGATION_MRI_XRay:
      return {
        ...state,
        inves_MRI_XRay: action.payload,
      };
    case INVESTIGATION_BLOOD_TEST:
      return {
        ...state,
        inves_blood_test: action.payload,
      };
    case INVESTIGATION_CATEGORY:
      return {
        ...state,
        inves_category: action.payload,
      };
    case INVESTIGATION_CATEGORY_DATA:
      return {
        ...state,
        category_master: action.payload,
      };
    case PRESCRIPTION_COUNT:
      return {
        ...state,
        prescription_count: action.payload,
      };
    case PRESCRIPTION_LOADER:
      return {
        ...state,
        prescription_loader: action.payload,
      };

    case ANTIBIOTIC_LOADER:
      return {
        ...state,
        antibiotic_loader: action.payload,
      };
    case DISEASE_LOADER:
      return {
        ...state,
        disease_loader: action.payload,
      };
    case LAB_LOADER:
      return {
        ...state,
        lab_loader: action.payload,
      };
    case RADIOLOGY_LOADER:
      return {
        ...state,
        radiology_loader: action.payload,
      };
    case SPECIALIZATION_LOADER:
      return {
        ...state,
        specialization_loader: action.payload,
      };
    case MRI_XRAY_LOADER:
      return {
        ...state,
        mri_xray_loader: action.payload,
      };
    case INVESCATEGORY_LOADER:
      return {
        ...state,
        invescategory_loader: action.payload,
      };
    case BLOODTEST_LOADER:
      return {
        ...state,
        bloodtest_loader: action.payload,
      };

    case MRD_NOTIFICATIONS:
      return {
        ...state,
        MTnotifications: action.payload,
      };

    case DIGIPOD_AUDIO_LIST:
      return {
        ...state,
        digiaudioList: action.payload,
      };
    case DIGIPOD_AUDIO_COUNT:
      return {
        ...state,
        audioCount: action.payload,
      };
    case DOWNLOAD_LINK:
      return {
        ...state,
        download_link: action.payload,
      };
    case GET_ERX_FORMS_PDF:
      return {
        ...state,
        getErxFormsPDF: action.payload,
      };
    case GET_REGISTERED_CLIENTS_DOCTORS:
      return {
        ...state,
        get_registered_clients_doctors: action.payload,
      };
    case REGI_REPORT_RESULT:
      return {
        ...state,
        rigireportresult: action.payload,
      };
    case ALTERNATIVE_MEDICINE_LIST:
      return {
        ...state,
        alternative_medicine_list: action.payload,
      };
    case TOTAL_MEDICINE:
      return {
        ...state,
        total_medicine: action.payload,
      };
    case TOTAL_UNIQUE_MEDICINE:
      return {
        ...state,
        unique_medicine: action.payload,
      };
    case ALTERNATIVE_MEDICINE_REPORT:
      return {
        ...state,
        excel_result: action.payload,
      };
    case MISSED_MEDICINE_LIST:
      return {
        ...state,
        missed_medicine_list: action.payload,
      };
    case MISSED_MEDICINE_REPORT:
      return {
        ...state,
        missed_medicine_export: action.payload,
      };
    case NEW_MEDICINE_LIST:
      return {
        ...state,
        new_medicine_list: action.payload,
      };
    case TOTAL_NEW_MEDICINE:
      return {
        ...state,
        total_new_medicine: action.payload,
      };
    case NEW_MEDICINE_REPORT:
      return {
        ...state,
        excel_new_medicines: action.payload,
      };
    case NEW_MEDICINE_SUGG_LIST:
      return {
        ...state,
        new_medicine_sugg_list: action.payload,
      };
    case TOTAL_NEW_MEDICINE_SUGG:
      return {
        ...state,
        total_new_medicine_sugg: action.payload,
      };
    case NEW_MEDICINE_SUGG_REPORT:
      return {
        ...state,
        excel_new_medicines_sugg: action.payload,
      };
    case DOCTORWISE_MISSEDMED_LIST:
      return {
        ...state,
        doctorwise_missed_medicine: action.payload,
      };
    case TOTAL_DOCTOR_LIST:
      return {
        ...state,
        total_doctor_list: action.payload,
      };
     case DOCTROWISEMISSED_MEDICINE_REPORT:
      return {
        ...state,
        doctorwise_excel: action.payload,
      };
      case ALTERNATIVE_UNIQUE_LIST:
        return {
        ...state,
        alternate_unique_list: action.payload,
      };
      case TOTAL_MEDICINE_RECORD:
        return {
        ...state,
        total_medicine_record: action.payload,
      };
       case UPLOAD_SIGNATURE_URL:
          return {
        ...state,
        uploaded_signature_url: action.payload,
      };
    case UPLOAD_SIGNATURE_STATUS:
      return {
        ...state,
        uploaded_signature_status: action.payload,
      };
      case CHART_ERX_RESULT:
      return {
        ...state,
        charteRxResult: action.payload,
      };
       case CHART_ERX_TOTAL_RECORD:
      return {
        ...state,
        chartErxTotalRecord: action.payload,
      };
      case CHART_ERX_DETAILS_LOADER:
        return{
          ...state,
          charteRxdetailsLoader: action.payload,
        };
      case PROCEDURE_LOADER:
      return {
        ...state,
      procedure_loader: action.payload,
      };
      case PROCEDURE_CHART_DATA:
         return {
        ...state,
      procedure_chart: action.payload,
      };
      case SUPER_ADMIN_CLIENTS:
         return {
        ...state,
      superAdminClients: action.payload,
      };
       case SADMIN_CLI_DTLS:
         return {
        ...state,
      sAdminCliDtls: action.payload,
      };
    case GET_FORMTYPE:
      return {
        ...state,
        formtype_master: action.payload,
      };
    default:
      return state;
  }
};
export default dashboardReducer;
